import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { GroupByOptions } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'app-assign-group-by',
  templateUrl: './assign-group-by.component.html',
  styleUrls: ['./assign-group-by.component.scss'],
  standalone: false,
})
export class AssignGroupByComponent implements OnInit, OnDestroy {
  @Output() groupChanged = new EventEmitter();
  @Input() disable: boolean = false;
  options: DropdownOption[];
  groupByFields: DropdownOption[] = [null];
  selectedGroups: string;

  getOptions(currentValue: number) {
    return this.options.filter((option) => !this.groupByFields.includes(option) || currentValue === option.value);
  }

  constructor() {}

  ngOnDestroy(): void {
    this.groupByFields = [];
    this.groupChanged.complete();
  }

  ngOnInit(): void {
    this.options = [
      {
        label: 'SKU',
        value: GroupByOptions.SKU,
      },
      {
        label: 'Package',
        value: GroupByOptions.BOX,
      },
      {
        label: 'Delivery method',
        value: GroupByOptions.DELIVERY_METHOD,
      },
      {
        label: 'Selected service level',
        value: GroupByOptions.SELECTED_RATE,
      },
      {
        label: 'Selected carrier',
        value: GroupByOptions.SELECTED_CARRIER,
      },
      {
        label: 'Country',
        value: GroupByOptions.COUNTRY,
      },
      {
        label: 'State',
        value: GroupByOptions.STATE,
      },
      {
        label: 'Inventory location',
        value: GroupByOptions.INVENTORY_LOCATION,
      },
      {
        label: 'Delivery promise',
        value: GroupByOptions.DELIVERY_PROMISE,
      },
      {
        label: 'Barcode',
        value: GroupByOptions.BARCODE,
      },
      {
        label: 'Color coding',
        value: GroupByOptions.COLOR_CODING,
      },
    ];
  }

  onOptionSelect(data: DropdownOption, index: number) {
    this.groupByFields[index] = data;
    this.updateSelectedTextGroup();
  }

  removeGroup(index: number) {
    this.groupByFields.splice(index, 1);
    this.updateSelectedTextGroup();
  }

  addGroup() {
    this.groupByFields.push(null);
  }

  updateSelectedTextGroup() {
    const groups = this.groupByFields.filter((group) => group?.value);
    this.selectedGroups = groups.length
      ? groups.length === 1
        ? `/${groups[0].label}`
        : `/${groups.length} Fields`
      : '';
    this.groupChanged.emit(groups);
  }
}
